'use client'

import { cn } from '@qr-front/ui/utils'
import { ComponentProps, useRef } from 'react'

import { TSvgIcon } from '@/types'

export const AllergensButton = ({
	name,
	Icon,
	isSelected,
	className,
	textClassName,
	...props
}: ComponentProps<'button'> & {
	name: string
	Icon: TSvgIcon
	isSelected?: boolean
	textClassName?: string
}) => {
	const buttonRef = useRef<HTMLButtonElement>(null)

	return (
		<button
			ref={buttonRef}
			className={cn(
				'relative flex size-fit shrink-0 items-center justify-center gap-2 rounded-8 p-2 ring-1 ring-inset ring-border-grey transition',
				isSelected && 'ring-2 ring-blue',
				className,
			)}
			{...props}
		>
			<Icon />
			<span className={cn('type-body-small', textClassName)}>{name}</span>
		</button>
	)
}
